//工作经验
export const workExpEnumList = [
  {
    name: '不限',
    id: -1
  },
  {
    name: '一年以内',
    id: 0
  },
  {
    name: '1-3年',
    id: 1
  },
  {
    name: '3-5年',
    id: 2
  },
  {
    name: '5-10年',
    id: 3
  },
  {
    name: '10年以上',
    id: 4
  }
]
 //   招聘类型列表
 export const jobTypeList=[
    {
      id: 0,
      name: "全职",
    },
    {
      id: 1,
      name: "兼职",
    },
  ]
//学历要求
export const xlList = [
  {
    name: '不限',
    id: -1
  },
  {
    name: '初中及以下',
    id: 0
  },
  {
    name: '中专/中技',
    id: 1
  },
  {
    name: '高中',
    id: 2
  },
  {
    name: '大专',
    id: 3
  },
  {
    name: '本科',
    id: 4
  },
  {
    name: '硕士',
    id: 5
  },
  {
    name: '博士',
    id: 6
  }
]
//薪资待遇
export const salaryList = [
  {
    name: '不限',
    hopeMaxSalary: '',
    hopeMinSalary: ''
  },
  {
    name: '5K以下',
    hopeMaxSalary: 5000,
    hopeMinSalary: ''
  },
  {
    name: '5-8K',
    hopeMaxSalary: 8000,
    hopeMinSalary: 5000
  },
  {
    name: '8-15K',
    hopeMaxSalary: 15000,
    hopeMinSalary: 8000
  },
  {
    name: '15-20K',
    hopeMaxSalary: 20000,
    hopeMinSalary: 15000
  },
  {
    name: '20-60K',
    hopeMaxSalary: 60000,
    hopeMinSalary: 20000
  },
  {
    name: '60K以上',
    hopeMaxSalary: '',
    hopeMinSalary: 60000
  },
]
// 求职状态
export const jobStatusList = [
  {
    name: '不限',
    id: -1
  },
  {
    name: '离职-想找工作',
    id: 0
  },
  {
    name: '在职-寻找机会',
    id: 1
  },
  {
    name: '在职-想换工作',
    id: 2
  },
  {
    name: '在职-不考虑',
    id: 3
  },
]
